module.exports = __webpack_public_path__ + "img/setting_3.a32d4296.svg";